<template>
  <div>
    <div class="headerLabelBox">
      <img src="@/assets/images/practice.png" alt="">
      <span>教官信息</span>
    </div>
    <div class="fenGeLine"></div>
    <div class="teacherdataheader">
      <div>头像</div>
      <div>姓名</div>
      <div>性别</div>
      <div>级别</div>
      <div>警种</div>
      <div>教官方向</div>
    </div>
    <div class="teacherdata">
      <div v-if="user.length!==0">
        <div v-for="(item,index) in user" :key="index">
          <div class="teacherMessage">
            <div @click="gopersonData(item)" style="cursor: pointer;">
              <img :src="item.photo" />
            </div>
            <div @click="gopersonData(item)" style="cursor: pointer;">
              <span class="teacherName">{{item.name}}</span>
            </div>
            <div>
              <span v-if="item.sex==true">男</span>
              <span v-else>女</span>
            </div>
            <div>{{item.jbdicname}}</div>
            <!-- <div>
              <span v-if="item.jzDicName==0">专职</span>
              <span v-else>兼职</span>
            </div>-->
            <div>{{item.jzdicname}}</div>
            <div style="text-align: left;">{{item.label}}</div>
          </div>
          <div class="hr"></div>
        </div>
      </div>
      <div v-else style="margin-top:20px">
        <nodata></nodata>
      </div>

      <div class="pageblock">
        <el-pagination
          v-if="dataCount>0"
          background
          prev-text="上一页"
          next-text="下一页"
          layout="total,prev, pager, next,jumper"
          :page-size="listQuery.limit"
          :current-page.sync="listQuery.page"
          :total="dataCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import * as teacherInfo from '@/api/teacher/teacherInfo';
export default {
  data() {
    return {
      dataCount: 0,
      listQuery: this.listQuerys,
      user: [],
    };
  },
  props: ['listQuerys'],
  created() {
    this.init();
  },
  mounted() {
    console.log(this.listQuerys);
  },
  methods: {
    //请求ajax将数据分页渲染
    init() {
      teacherInfo.getList(this.listQuery).then((response) => {
        this.dataCount = response.count;
        this.user = response.data;
      });
    },
    changeColor(resultsList) {
      // resultsList全部数据，改变title里的高亮颜色，用正则先去匹配全局匹配到，然后用字符串的替换将原来的title替换需要高亮的部分
      resultsList.map((item, index) => {
        // console.log('item', item)
        if (this.listQuerys.Name && this.listQuerys.Name.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(this.listQuerys.Name, 'gi');
          // 高亮替换v-html值
          let replaceString =
            '<span class="search-text" style="color:red;">' +
            this.listQuerys.Name +
            '</span>';
          resultsList[index].name = item.name.replace(
            replaceReg,
            replaceString
          );
        }
      });
      // this.results = []
      // this.results = resultsList
      this.user = [];
      this.user = resultsList;
      console.log(this.user);
    },
    // 分页组件的页数跳转方法
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.init();
    },
    gopersonData(item) {
      // console.log(item);
      //点击跳转到个人数据页面
      this.$router.push({
        path: '/diaoa/personData',
        query: {
          id: item.userid,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.headerLabelBox{
  display: flex;
  align-items: center;
  padding: 14px 0px 5px 31px;
  box-sizing: border-box;
  border-radius: 6px 6px 0 0;
  background-color: #fff;
  &>img{
    width: 40px;
    height: 40px;
    margin-right: 20px;
  }
  &>span{
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
}

.fenGeLine{
  background: linear-gradient(to right, #4192FF, #DB4144);
  height: 2px;
  width: 100%;
}

.teacherdataheader {
  width: 100%;
  background-color: #fff;
  display: flex;
  line-height: 24px;
  font-size: 16px;
  padding: 18px 0px;
  color: #999999;
}
.teacherdataheader > div {
  text-align: center;
  flex: 1;
}
.teacherdataheader > div:nth-child(6) {
  text-align: center;
  flex: 2;
}
.teacherdata {
  background-color: #ffffff;
  width: 100%;
  padding: 0px 26px;
  box-sizing: border-box;
  // max-height: 1373px;
}
.teacherMessage {
  padding: 10px 0;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
}

.teacherMessage > div{
  font-size: 16px;
  line-height: 24px;
  color: #272636;
  font-weight: 350;
}

.teacherMessage > div:nth-child(1) {
  flex: 1;
}
.teacherMessage > div:nth-child(1) > img {
  width: 72px;
  height: 85px;
  margin-top: 4px;
  flex: 1;
}
.teacherMessage > div:nth-child(1) > img:hover {
  transform: scale(1.02);
}
.teacherMessage > div:nth-child(2) {
  width: 32px;
  flex: 1;
}
.teacherMessage > div:nth-child(3) {
  width: 32px;
  flex: 1;
}
.teacherMessage > div:nth-child(4) {
  width: 32px;
  flex: 1;
}
.teacherMessage > div:nth-child(5) {
  width: 100px;
  flex: 1;
}
.teacherMessage > div:nth-child(6) {
  width: 100px;
  flex: 2;
}
.hr {
  width: 100%;
  height: 0px;
  border-bottom: 1px solid #efefef;
  opacity: 1;
}
.pageblock {
  margin-top: 18px;
  text-align: center;
}
.teacherName:hover {
  color: #1492ff;
  border-bottom: 1px solid #1492ff;
}
</style>